<div class="input-group mt-3 mt-md-0 search-class-margin header-search-group">
  <p-autoComplete #autoComplete [(ngModel)]="this.ddpDataStore.text"
    [minLength]="minimumSearchLength"
    [maxlength]="maximumSearchLength"
    [delay]="200"
    [autoHighlight]="true"
    [autofocus]="true"
    [showClear]="false"
    [lazy]="true"
    [showEmptyMessage]="true"
    [emptyMessage]="'No result found'"
    [panelStyleClass]="'panelClass'"
    (onSelect)="onSelectEvent($event)"
    (onKeyUp)="onKeyUpEvent($event)"
    (onFocus)="onFocusEvent($event)"
    [className]="'form-control header-search-class header-search-class-2 custom-width'"
    [suggestions]="results"
    (onShow)="onShowOverlay()"
    (completeMethod)="search($event)"
    (input)="filterIllegalCharacters($event)">
    <ng-template let-item pTemplate="item">
      <span [innerHTML]="highlightMatch(item.word, this.ddpDataStore.text)"></span>
    </ng-template>
  </p-autoComplete>

  <div class="search-btn-wrapper">
    <button class="btn search-btn-inside" (click)="searchOnClick($event)" type="button">
      <img class='search-icon-img' src="assets/images/searchicon.png">
      <span class="search-btn-label">Search</span>
    </button>
  </div>
</div>
